import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import type { RootState } from "../store";

// Define a type for the slice state
interface RessourcesState {
  ressources: [];
}

// Define the initial state using that type
const initialState: RessourcesState = {
  ressources: [],
};

export const ressourcesSlice = createSlice({
  name: "ressources",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    // Use the PayloadAction type to declare the contents of `action.payload`
    setGlobalRessources: (state, action: PayloadAction<any>) => {
      state.ressources = action.payload;
    },
  },
});

export const { setGlobalRessources } = ressourcesSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const getRessources = (state: RootState) => state.ressources;
export default ressourcesSlice.reducer;
